import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";

import { CommonLoader } from "@common";

const TalenaiseLayout = lazy(
  () => import("../components/talenaise/TalenaiseLayout"),
);
const TalenaiseDashboardLayout = lazy(
  () => import("../components/dashboard/TalenaiseDashboardLayout"),
);

const TalenasieSetupLayout = lazy(
  () => import("../components/setup/TalenasieSetupLayout"),
);
const PlatformTalenaiseLayout = lazy(
  () => import("../components/platform/PlatformConfigurationLayout"),
);

const AssessmentPreview = lazy(
  () => import("../components/preview/preview-questions/AssessmentPreview"),
)
// ===============================================================================================================
const index = () => {
  return (
    <Suspense fallback={<CommonLoader />}>
      <Routes>

        <Route path="/" element={<TalenaiseLayout />} />

        <Route path="dashboard" element={<TalenaiseDashboardLayout />} />

        <Route path="setup" element={<TalenasieSetupLayout />} />
        <Route path="platform" element={<PlatformTalenaiseLayout />} />
        
        <Route path="assessmentPreview" element={<AssessmentPreview />} />

      </Routes>
    </Suspense>
  );
};

export default index;
